import { EMkAuthenticationAction, IMkAuthenticatedSession, IMkAuthorizedSession, IMkUser, TMkAuthenticationAction } from '@features/authentication/types'
import { Tokens } from '@okta/okta-auth-js'

type InitializeSessionFn = (user: Record<string, any>, sessionToken: string, codeVerifier: string) => Promise<void>
type AuthorizeSessionFn = (initializedSession: IMkAuthenticatedSession, user: IMkUser, oktaUserName: string) => Promise<IMkAuthorizedSession>
type GetAuthenticatedSessionFn = () => IMkAuthenticatedSession | null

export async function mockLogin(
  username: string,
  initializeSession: InitializeSessionFn,
  authorizeSession: OmitThisParameter<(initializedSession: IMkAuthenticatedSession, makoUser: IMkUser, oktaUserName: string, tokens: Tokens) => Promise<IMkAuthorizedSession>>,
  getAuthenticatedSession: GetAuthenticatedSessionFn,
  dispatch: React.Dispatch<TMkAuthenticationAction>,
): Promise<void> {
  const mockUser: IMkUser = {
    memberNumber: '12345678',
    username,
    email: `${username}@example.com`,
    first: 'Mock',
    last: 'User',
    tier: 'Gold',
    totalCredits: '200',
    availableCredits: '150',
    useByDate: '2024-12-31',
    totalPoints: '2000',
    availablePoints: '1500',
    sub: `okta_${username}`,
    accessCode: 'mock-access-code',
    memberAccessToken: 'mock-member-access-token',
    jwtToken: 'mock-jwt-token',
  }

  await initializeSession(mockUser, 'mock-session-token', 'mock-code-verifier')

  const authenticatedSession = getAuthenticatedSession()
  if (authenticatedSession) {
    await authorizeSession(authenticatedSession, mockUser, username)
  }

  dispatch({ type: EMkAuthenticationAction.RESET_FAILED_ATTEMPTS })
}

export async function mockAuthorizeOnCallback(
  getAuthenticatedSession: GetAuthenticatedSessionFn,
  authorizeSession: OmitThisParameter<(initializedSession: IMkAuthenticatedSession, makoUser: IMkUser, oktaUserName: string, tokens: Tokens) => Promise<IMkAuthorizedSession>>,
  onAuthorizedSession: (session: IMkAuthorizedSession) => void,
  onFailedToAuthorize: (error?: Error) => void,
): Promise<void> {
  const authenticatedSession = getAuthenticatedSession()
  if (authenticatedSession && authenticatedSession.authenticatedUser) {
    const base = authenticatedSession.authenticatedUser as Partial<IMkUser>
    const username = base.username || authenticatedSession.username || 'mockuser'
    const mockUser: IMkUser = {
      memberNumber: base.memberNumber || '12345678',
      username,
      email: base.email || `${username}@example.com`,
      first: base.first || 'Mock',
      last: base.last || 'User',
      tier: base.tier || 'Gold',
      totalCredits: base.totalCredits || '200',
      availableCredits: base.availableCredits || '150',
      useByDate: base.useByDate || '2024-12-31',
      totalPoints: base.totalPoints || '2000',
      availablePoints: base.availablePoints || '1500',
      sub: base.sub || `okta_${username}`,
      accessCode: 'mock-access-code',
      memberAccessToken: 'mock-member-access-token',
      jwtToken: 'mock-jwt-token',
    }

    const authorizedSession = await authorizeSession(authenticatedSession, mockUser, username)
    onAuthorizedSession(authorizedSession)
    return
  }
  onFailedToAuthorize(new Error('Mock authorization failed'))
}
